import "../styles/about.css";

export default function About() {
  return (
    <>
    <div className="about-wrapper">
      <section className="about-intro">
        <h2 className="about-title">About Me</h2>
        <p className="about-quote">
          “Healing is the journey of removing the darkness and discovering the real you, the eternal oneness.To live from this essence is Onenessence.”
        </p>

        <div className="about-container">
          <div className="about-image">
            <img src="/images/profile.png" alt="Divya" />
          </div>
          <div className="about-text">
            <p>Welcome to Onesssencce. My name is Divya, and I am here to guide souls on their journey of healing,
              awakening, and returning to their true essence.
            <br/>
           From a young age, I felt deeply connected to the unseen realms and the universal flow of energy. Life experiences and inner callings led me to explore the depths of spirituality, self-realization, and soul healing. Along this path, I discovered that true healing is not just about removing pain or fixing symptoms, it is about remembering who we really are, beyond fears, patterns, and karmic imprints.
          </p>
          <p>
          My spiritual path began when I was just 10 years old, when I first experienced pain in my third eye. Without guidance, I tried to ignore it, yet I always felt an inner whisper that I was not following my true path. My first awakening began around 2013, when I started feeling a deep sense of not belonging anywhere. It was the beginning of my ego dissolution, a phase where the universe slowly began stripping away my illusions. I observed that whenever I tried to seek validation, security, or fulfillment from the outside world, something within would resist it. Layer by layer, the false identities started breaking down, even though I did not fully understand what was happening at that time.For many years, I resisted the spiritual process and instead focused on the outside world, excelling in academics, chasing degrees, and pursuing a good job. But none of it aligned with my soul. The more I resisted, the more the universe resisted me back. Eventually, the imbalance drained me to the point where I was almost bedridden.
            Then in 2020, everything changed. A powerful spiritual awakening was triggered, followed by a deep inner transformation. I finally received the answers I had been seeking for so long. With universal support guiding me, I immersed myself in all forms of healing, from energetic practices to non-dual wisdom. Through this journey, I discovered my spiritual gifts and began channeling wisdom that healed me from within. I moved from a place of darkness and hopelessness into a life filled with light, love, and purpose.
          <br/>
          Now, it is my mission to help others to heal their lives, release resistance, and return to the space of love, joy, and wholeness within.
          </p>
          </div>
        </div>
      </section>

      {/* MAIN ABOUT CONTENT */}
      <section className="about-section">
        <div className="about-work">
          <p>
            Through my work, I blend ancient wisdom with intuitive guidance to create a safe space for transformation.
          </p>

          <ul className="healing-list">
            <li>✨ Past Life Regression</li>
            <li>✨ Akashic Records Healing</li>
            <li>✨ Ancestral Lineage Healing</li>
            <li>✨ Sacred Energy & Womb Clearing</li>
            <li>✨ Aura Cleansing with Reiki & Angel Therapy</li>
            <li>✨ Spiritual Healing of Disease</li>
            <li>✨ Manifestation & Soul Alignment</li>
          </ul>

          <p className="welcome-text">🌷 Welcome home to yourself.</p>
        </div>
      </section>
      </div>
    </>
  );
}
